import { useState } from 'react'
import { USAMapSelect } from 'react-usa-map-select'

export function USAInteractiveMap({ selectedState, onStateSelect }) {
  const handleStateClick = (event) => {
    const stateName = event.currentTarget.getAttribute('name')
    onStateSelect(stateName)

    // Reset all fills
    document.querySelectorAll('path').forEach((path) => {
      path.style.fill = ''
    })

    // Highlight clicked state
    event.target.style.fill = 'rgb(59, 130, 246)' // blue-600
  }

  const getAllStatesStyles = () => {
    const states = [
      'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY',
      'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND',
      'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'
    ]

    const styles = {}

    states.forEach((state) => {
      styles[state] = {
        fill: selectedState === state ? '#3b82f6' : '#e5e7eb', // blue-600 if selected, gray-200 default
        stroke: '#ffffff',
        strokeWidth: selectedState === state ? 2 : 1,
        transition: 'fill 0.3s ease',
      }
    })

    return styles
  }

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6">
      <USAMapSelect
        onClick={handleStateClick}
        onUSAStateMouseEnter={(e) => {
          e.target.style.cursor = 'pointer'
        }}
        onUSAStateMouseLeave={(e) => {
          e.target.style.cursor = 'default'
        }}
        showStateNameOnHover
        USAStateOnHoverColor="#93c5fd" // blue-300
        USAStateOnHoverStrokeColor="white"
        customStateStyles={getAllStatesStyles()}
      />
    </div>
  )
}
